
// Angular
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, CanActivateChild } from '@angular/router';
// RxJS

// NGRX
import { select, Store } from '@ngrx/store';
// Module reducers and selectors
import { AppState } from '../../../core/reducers/';

import { RoleService } from '../../../modules/management/shared/services/roleService';

@Injectable()
export class ModuleGuard implements CanActivate {
    constructor(private store: Store<AppState>, private router: Router, private roleService: RoleService) {

    }

    async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
        const userPermission = route.data['permission'] as string;
        if (!userPermission) {
            return false;
        }
        var res =  this.roleService.haveRole(userPermission);
        if (res)
            return true;
        else
            this.router.navigateByUrl('account/error/403');

    }
}
